import React from "react"
import { Col, Row } from "reactstrap"
import ViewMode from "./ViewMode"
import EditMode from "./EditMode"
import { isEmptyValues } from "helpers/utilities"

const TabDetails = ({ isEdit, data, onValidSubmit, onCancel, listDeliveryType }) => {
  if (isEdit && isEmptyValues(data)) return null
  return (
    <Row>
      <Col sm="12">
        {/* ViewMode Form */}
        {isEdit ? (
          <EditMode
            onValidSubmit={onValidSubmit}
            data={data}
            onCancel={onCancel}
            isEdit={isEdit}
            listDeliveryType={listDeliveryType}
          />
        ) : (
          <ViewMode data={data} />
        )}
      </Col>
    </Row>
  )
}

export default TabDetails
